import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59297618"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "assets/logo.png",
  width: "16",
  class: "mr-10"
}, null, -1))
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "d-flex justify-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-profile text-center my-6 cursor-pointer" }
const _hoisted_6 = { class: "d-flex justify-space-between" }

import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { MoleculeModal, MoleculeModalAlert, MoleculeUploadProfile } from '../molecules';
import {
  DashboardIcon,
  DocumentTextIcon,
  CollaboratorsIcon,
  GoalsIcon,
  LogoutIcon,
  AtomButton,
  AtomSelectFlag,
  ProfileIcon,
  AtomInput,
  SettingIcon,
  ExcludeIcon,
  PhoneRingIcon,
  AdressIcon,
  PersonalIdDarkIcon,
  TutorialIcon,
  ReportIcon
} from '../atoms';
import { Authentication } from '@/store';
import { User } from '@/core/model';
import { getBy, getByProfile, update, update_form_data } from '@/core/service/UsersService';
import { Preloader } from '@/store';
import Swal from 'sweetalert2';
import { carousselLoaded, isFilterTutorial, isTutorial, showTutorial } from '@/store/modules/subBar';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsBar',
  setup(__props) {

const router = useRouter();
const user = ref<User>({});
const keyImageProfile = ref(0);

const userOld = ref<User>({});
const inputfile = ref<any>(null);
const fileBase64 = ref<any>('');
const route = useRoute();

let image_path: string;

const hoverTab = ref('')

function isColab() {
  return (
    route.name == 'Colaboradores' ||
    ((Authentication.getters.isAdmin.value || Authentication.getters.isMaster.value) && route.name == 'Dashboard')
  );
}

function isMeta() {
  return route.name == 'Metas' || route.name == 'CadastrarMetas';
}

function handleImage(event: any) {

  const file = event.target.files[0];
  if (!file) {
    return;
  }

  const reader = new FileReader();

  reader.onload = function () {
    fileBase64.value = reader.result;
    inputfile.value = null

  };
  reader.readAsDataURL(file);
  user.value.image_url = file;
}

const showModal = ref<boolean>(false);
const IconAdress = ref<boolean>(true);
const showModalProfile = ref<boolean>(false);

function saveProfile() {
  let form_data = new FormData();
  Preloader.actions.ActionSetPreloader(true);

  Object.keys(user.value).map(key => {
    form_data.append(key, user.value[key]);
  });
  update_form_data(user.value.id as number, form_data).then(() => {
    Swal.fire({
      icon: "success",
      title: "Sucesso",
      text: "Dados foram atualizados com sucesso"
    }).then(() => {
      if(Authentication.state.value && Authentication.state.value.user && user.value.image_url)
      {
        getByProfile().then((u) => {
          let usuario = Authentication.getters.getUser.value;
          if(usuario.user)
          {
            usuario.user.image_url = u.image_url;
            Authentication.actions.setUser(usuario);
            window.location.reload();
          }
        });
      }
      showModalProfile.value = false;
    })
  }).finally(() => {
    Preloader.actions.ActionSetPreloader(false);
  })
}

function emptyinput(field: string) {
  IconAdress.value = false;
  user.value[field] = undefined;
  userOld.value[field] = undefined;
}

function handleModalProfile() {
  Preloader.actions.ActionSetPreloader(true);
  showModalProfile.value = true;

  getByProfile()
    .then((f) => {
      user.value = f;
      fileBase64.value = `${process.env.VUE_APP_API_URL.replace("/api", '')}${user.value.image_url}`;
      userOld.value = JSON.parse(JSON.stringify(f));
    })
    .finally(() => {
      Preloader.actions.ActionSetPreloader(false);
    });
}

function handleLogout() {
  Authentication.actions.logout();
  router.push({ name: 'Login' });
}

function handleTutorial()
{
  isFilterTutorial.value = !isFilterTutorial.value;
  showTutorial.value = true;
  isTutorial.value = true;

  carousselLoaded.value = !carousselLoaded.value;
  setTimeout(() => { carousselLoaded.value = !carousselLoaded.value; }, 5)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      app: "",
      color: "#ffffff",
      height: "100",
      style: {"padding":"0 50px 0 55px"}
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        (_unref(Authentication).getters.isAdmin.value && !_unref(Authentication).getters.isMaster.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'Meu Perfil' },
              class: _normalizeClass(["menu-option", { active: _ctx.$route.name == 'Meu Perfil' }]),
              onMouseover: _cache[0] || (_cache[0] = ($event: any) => (hoverTab.value = 'Meu Perfil')),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoverTab.value = ''))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DashboardIcon), {
                  class: "mr-2",
                  color: _ctx.$route.name == 'Meu Perfil' ? 'active' : (hoverTab.value == 'Meu Perfil' ? 'hover' : 'default')
                }, null, 8, ["color"]),
                _createTextVNode(" Meu Perfil ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (!_unref(Authentication).getters.isAdmin.value && !_unref(Authentication).getters.isMaster.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: 'Dashboard' },
              class: _normalizeClass(["menu-option v-step-dashboard-navigation", { active: _ctx.$route.name == 'Dashboard' }]),
              onMouseover: _cache[2] || (_cache[2] = ($event: any) => (hoverTab.value = 'Dashboard')),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (hoverTab.value = ''))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DashboardIcon), {
                  class: "mr-2",
                  color: _ctx.$route.name == 'Dashboard' ? 'active' : (hoverTab.value == 'Dashboard' ? 'hover' : 'default')
                }, null, 8, ["color"]),
                _createTextVNode(" Dashboard ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_unref(Authentication).getters.isAdmin.value || _unref(Authentication).getters.isMaster.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: { name: 'Colaboradores' },
              class: _normalizeClass(["menu-option", { active: isColab() }]),
              onMouseover: _cache[4] || (_cache[4] = ($event: any) => (hoverTab.value = 'Colaboradores')),
              onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (hoverTab.value = ''))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CollaboratorsIcon), {
                  class: "mr-2",
                  color: isColab() ? 'active' : (hoverTab.value == 'Colaboradores' ? 'hover' : 'default')
                }, null, 8, ["color"]),
                _createTextVNode(" Colaboradores ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: { name: 'Metas' },
          class: _normalizeClass(["menu-option v-step-goals-navigation", { active: isMeta() }]),
          onMouseover: _cache[6] || (_cache[6] = ($event: any) => (hoverTab.value = 'Metas')),
          onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (hoverTab.value = ''))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(GoalsIcon), {
              class: "mr-2",
              color: isMeta() ? 'active' : (hoverTab.value == 'Metas' ? 'hover' : 'default')
            }, null, 8, ["color"]),
            _createTextVNode(" Metas ")
          ]),
          _: 1
        }, 8, ["class"]),
        (_unref(Authentication).getters.isAdmin.value || _unref(Authentication).getters.isMaster.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: { name: 'Notas' },
              class: _normalizeClass(["menu-option", { active: _ctx.$route.name == 'Notas' }]),
              onMouseover: _cache[8] || (_cache[8] = ($event: any) => (hoverTab.value = 'Notas')),
              onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (hoverTab.value = ''))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DocumentTextIcon), {
                  class: "mr-2",
                  color: _ctx.$route.name == 'Notas' ? 'active' : (hoverTab.value == 'Notas' ? 'hover' : 'default')
                }, null, 8, ["color"]),
                _createTextVNode(" Notas ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_unref(Authentication).getters.isAdmin.value || _unref(Authentication).getters.isMaster.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 4,
              to: { name: 'Relatórios' },
              class: _normalizeClass(["menu-option", { active: _ctx.$route.name == 'Relatórios' }]),
              onMouseover: _cache[10] || (_cache[10] = ($event: any) => (hoverTab.value = 'Relatórios')),
              onMouseleave: _cache[11] || (_cache[11] = ($event: any) => (hoverTab.value = ''))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ReportIcon), {
                  class: "mr-2",
                  color: _ctx.$route.name == 'Relatórios' ? 'active' : (hoverTab.value == 'Relatórios' ? 'hover' : 'default')
                }, null, 8, ["color"]),
                _createTextVNode(" Relatórios ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_unref(Authentication).getters.isAdmin.value || _unref(Authentication).getters.isMaster.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 5,
              to: { name: 'Configurações' },
              class: _normalizeClass(["menu-option", { active: _ctx.$route.name == 'Configurações' }]),
              onMouseover: _cache[12] || (_cache[12] = ($event: any) => (hoverTab.value = 'Configurações')),
              onMouseleave: _cache[13] || (_cache[13] = ($event: any) => (hoverTab.value = ''))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SettingIcon), {
                  class: "mr-2",
                  color: _ctx.$route.name == 'Configurações' ? 'active' : (hoverTab.value == 'Configurações' ? 'hover' : 'default')
                }, null, 8, ["color"]),
                _createTextVNode(" Configurações ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_spacer),
        _createElementVNode("div", _hoisted_2, [
          (1==2)
            ? (_openBlock(), _createBlock(_unref(AtomSelectFlag), {
                key: 0,
                class: "mr-2",
                options: [
        { text: 'Português', value: 'br', selected: true },
        { text: 'Inglês', value: 'usa', selected: true },
        { text: 'Espanhol', value: 'es', selected: true },
      ],
                id: "v-step-language-button"
              }))
            : _createCommentVNode("", true),
          (!_unref(Authentication).getters.isMasterOrAdmin.value)
            ? (_openBlock(), _createBlock(_unref(AtomButton), {
                key: 1,
                background: "transparent",
                noHover: "",
                class: "pa-0",
                onClick: handleTutorial,
                id: "v-step-tutorial-button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TutorialIcon))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(AtomButton), {
            background: "transparent",
            noHover: "",
            class: "pa-0 mx-6",
            onClick: handleModalProfile,
            id: "v-step-profile-button"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ProfileIcon))
            ]),
            _: 1
          }),
          _createVNode(_unref(AtomButton), {
            background: "transparent",
            noHover: "",
            class: "pa-0",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (showModal.value = true)),
            id: "v-step-logout-button"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LogoutIcon))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(MoleculeModalAlert), {
      "show-alert-confirm": showModal.value,
      icon: 'AtomLogout',
      text: "Certeza que deseja sair?",
      onCancel: _cache[15] || (_cache[15] = ($event: any) => (showModal.value = false)),
      onConfirm: handleLogout
    }, null, 8, ["show-alert-confirm"]),
    _createVNode(_unref(MoleculeModal), {
      width: "480px",
      "padding-y": "32px",
      onHandleCancel: _cache[17] || (_cache[17] = ($event: any) => (showModalProfile.value = false)),
      title: "Perfil",
      showHeader: false,
      showFooter: false,
      persistent: false,
      show: showModalProfile.value,
      "btn-close-text": "Cancelar"
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: fileBase64.value || 'assets/profileTeste.png',
              class: "rounded-profile",
              crossorigin: "anonymous"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("label", _hoisted_5, [
            _createTextVNode("Alterar foto de perfil "),
            _createElementVNode("input", {
              ref_key: "inputfile",
              ref: inputfile,
              type: "file",
              accept: "image",
              class: "sr-only",
              onChange: handleImage
            }, null, 544)
          ]),
          _createVNode(_component_v_divider, { class: "mb-8" }),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(AtomButton), {
              background: "transparent",
              class: "btn-actions-profile btn-back-button",
              noHover: "",
              outlined: "",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (showModalProfile.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Voltar ")
              ]),
              _: 1
            }),
            _createVNode(_unref(AtomButton), {
              class: "btn-confirm btn-actions-profile",
              onClick: saveProfile
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Confirmar ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})